export const product = [
    {
      name: "Internal 24 X DVD Burner",
      price: "3,000",
      image: "https://images-cdn.ubuy.co.in/633fd4d88b53ac549363be17-brand-new-laptop-internal-9-5mm-sata-dvd.jpg",
      description: "ASUS DRW-24D5MT (Black)"
    },
    {
      name: "Internal SSD",
      price: "11,499",
      image: "https://m.media-amazon.com/images/I/71XHEQZZW+L.jpg",
      description: "Samsung 970 EVO Plus 1TB M.2 NVMe SSD"
    },
    {
      name: "Motherboard",
      price: "19,020",
      image: "https://4.imimg.com/data4/YX/RP/MY-2297750/cpu-motherboard-500x500.jpg",
      description: "ASUS Pro H610M-CT D4-CSM LGA 1700 Micro-ATX"
    },
    {
      name: "Graphic Card",
      price: "3,999",
      image: "https://serverbazar.in/wp-content/uploads/2022/04/nvidia-t1000-graphic-cards.jpg",
      description: "ZEBRONICS GT740-4GD3"
    },
    {
      name:  "Hard Drive for Desktop (HDD)",
      price: "1,299",
      image: "https://m.media-amazon.com/images/I/71H5F9t0mNL._AC_UF1000,1000_QL80_.jpg",
      description: "500GB SATA"
    },
    {
      name: "Power Supply",
      price: "3,999",
      image: "https://5.imimg.com/data5/SELLER/Default/2021/1/FI/YM/KU/46386073/power-supply-unit-500x500.jpg",
      description:  "Circle RAW POWER 650 WATTS"
    },
    {
      name:  "Crucial RAM",
      price: "1,299",
      image: "https://masasouq.com/uploads/images/202305/img_1920x_6459f8fd77e509-81454208-97362581.jpg",
      description:"8GB DDR4 3200MHz CL22"
    },
    {
      name: "WiFi Card AC600 For Desktop PC",
      price: "1,299",
      image: "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcSQXtRPtFcC_kl3t6UNuT_56XqiASKS19CCOcXiM4Oa69oqe_IAWCvqLo4TQnAaCi1SCHVnCZq0-2XSbuduKVy0Sf3Ph_wkoJXfMwtuT4Z7&usqp=CAE",
      description: "TP-Link Dual Band Wireless"
    },
    {
      name:  "Gaming Cabinet-White",
      price: "7,349",
      image: "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcSYXzpQLJc6ZYzWbxCycjfBC9VYUEkKZM9bBcqFfKkxe4MfrTmDceaHDdbIXyVxkdLRvH6bV5joFqbUQAPmZEUaOMmDHufF&usqp=CAE",
      description: "Elegantor M3 Glass Tower Computer Case"
    },
    {
      name: "CPU Liquid Cooler",
      price: "8,999",
      image: "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcTCjn1qfU8-q3bFvofm8TY_AZi9IvdliDDcnEdDlFesrSABvz6m5M8QdIr1Jv1WzzB3uAgAIZCuk4pjniu0SPu9GNSM1G82KwoChPcnWVp05Q5DiKUMbycdWA&usqp=CAE",
      description: "COOLER MASTER MasterLiquid 240L Core 240mm"
    },
    {
      name:  "ARGB Liquid Cooler",
      price: "6,209",
      image: "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcQsDmMKni2JGEzmB70emKJn5T_EYCyGHeCctYUBCurLETMUIsCsvxASqjJgFgS1kTJs8aUOF1F7bRMyVwUey3PWsgWheJ2L9KM8waqO-VQJQMdvVXcXUSgU&usqp=CAE",
      description: "Deepcool Castle 240 RGB"
    },
    {
      name: "Verity Iceberg CPU Air Cooler",
      price: "2,650",
      image: "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcRr2KROp7N8UMr9w0_PHnt8yq8U6dAHthNHHGKzvU-hm_Kci6TiNdu3mZ9gg6JjrXRhAX4XKAIXckwU5NHe26Xo2GADc_bAGDCEPt2tx-4eA0tQM1_cVNH4&usqp=CAE",
      description: "CPu Air Cooler"
    },
    {
      name: "Power Supply Unit (PSU)",
      price: "6,255",
      image: "https://m.media-amazon.com/images/I/710YVc9mZ1L._AC_UY218_.jpg",
      description: "CORSAIR CX Series CX750 80 Plus Bronze ATX",
    },
    {
      name: "Desktop Processor 24 Core",
      price: "50,299",
      image: "https://itprice.in/wp-content/uploads/2024/04/61GbKtxb57L._SX569_.jpg",
      description: "Intel Core I9-14900K",
    },
    {
      name: "Internal SSD",
      price: "10,499",
      image: "https://gamesncomps.com/wp-content/uploads/2021/01/814KAQVF6YL._SL1500_-1.jpg",
      description: "Basssy 2TB 2.5-Inch SATA Internal SSD"
    },

  ];